import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CircularUnderLoad from './CircularUnderLoad';
import ClientProvider from './client';
export default createDemo(import.meta.url, CircularUnderLoad, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/circular-under-load/CircularUnderLoad.tsx",
    "fileName": "CircularUnderLoad.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import CircularProgress from '@mui/material/CircularProgress';\n\nexport default function CircularUnderLoad() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <CircularProgress disableShrink aria-label=\"Loading…\" />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 7,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import CircularProgress from '@mui/material/CircularProgress';\n\nexport default function CircularUnderLoad() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <CircularProgress disableShrink aria-label=\"Loading…\" />\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 5
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "CircularProgress"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disableShrink"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Loading…",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 7,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "@mui/material/CircularProgress"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
